var map = {
	"./white/0.25.svg": 756,
	"./white/0.5.svg": 757,
	"./white/0.75.svg": 758,
	"./white/0.svg": 759,
	"./white/1.svg": 760,
	"./white/10.svg": 761,
	"./white/11.svg": 762,
	"./white/2.svg": 763,
	"./white/3.svg": 764,
	"./white/4.svg": 765,
	"./white/5.svg": 766,
	"./white/6.svg": 767,
	"./white/7.svg": 768,
	"./white/8.svg": 769,
	"./white/9.svg": 770,
	"./yellow/0.25.svg": 771,
	"./yellow/0.5.svg": 772,
	"./yellow/0.75.svg": 773,
	"./yellow/0.svg": 774,
	"./yellow/1.svg": 775,
	"./yellow/10.svg": 776,
	"./yellow/11.svg": 777,
	"./yellow/2.svg": 778,
	"./yellow/3.svg": 779,
	"./yellow/4.svg": 780,
	"./yellow/5.svg": 781,
	"./yellow/6.svg": 782,
	"./yellow/7.svg": 783,
	"./yellow/8.svg": 784,
	"./yellow/9.svg": 785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 755;